const config = {
    source: {
        columns: [
            {
                prop: '',
                label: '',
            },
        ],
        action: [],
        // actionWidth: 100,
    },
    delegate: {
        columns: [
            {
                prop: 'mainLogicalWarehouseName',
                label: '主工作逻辑仓',
            },
            {
                prop: 'supplierName',
                label: '供应商',
            },
            {
                prop: 'workerName',
                label: '姓名',
            },
            {
                prop: 'supplierSignStatus',
                label: '供应商签署状态',
                type: 'select',
                optionNum: 'SRM_SUPPLIER_DELEGATE_STATUS',
                colorPoints: [
                    {
                        color: '#F44837',
                        value: '-1',
                    },
                    {
                        color: '#C0C5CF',
                        value: '0',
                    },
                    {
                        color: '#0BB861',
                        value: '1',
                    },
                    {
                        color: '#2881FF',
                        value: '2',
                    },
                    {
                        color: '#C0C5CF',
                        value: '3',
                    },
                ],
            },
            {
                prop: 'warehouseWorkerSignStatus',
                label: '仓库人员签署状态',
                type: 'select',
                optionNum: 'WAREHOUSE_SIGN_STATUS',
                colorPoints: [
                    {
                        color: '#F44837',
                        value: '-1',
                    },
                    {
                        color: '#C0C5CF',
                        value: '0',
                    },
                    {
                        color: '#0BB861',
                        value: '1',
                    },
                    {
                        color: '#2881FF',
                        value: '2',
                    },
                    {
                        color: '#C0C5CF',
                        value: '3',
                    },
                ],
            },
            {
                prop: 'auditStatus',
                label: '审批状态',
                type: 'select',
                optionNum: 'WAREHOUSE_DELEGATE_AUDIT_STATUS',
                colorPoints: [
                    {
                        color: '#C0C5CF',
                        value: '00',
                    },
                    {
                        color: '#C0C5CF',
                        value: '01',
                    },
                    {
                        color: '#2881FF',
                        value: '10',
                    },
                    {
                        color: '#C0C5CF',
                        value: '2',
                    },
                    {
                        color: '#0BB861',
                        value: '20',
                    },
                    {
                        color: '#FFA628',
                        value: '3',
                    },
                    {
                        color: '#F44837',
                        value: '30',
                    },
                    {
                        color: '#C0C5CF',
                        value: '40',
                    },
                    {
                        color: '#C0C5CF',
                        value: '80',
                    },
                ],
            },
        ],
        // action: [],
        // actionWidth: 100,
    },
    salary: {
        columns: [
            {
                prop: 'mainLogicalWarehouseName',
                label: '主工作逻辑仓',
            },
            {
                prop: 'supplierName',
                label: '供应商',
            },
            {
                prop: 'workerName',
                label: '姓名',
            },
            {
                prop: 'confirmStatus',
                label: '工资确认',
                type: 'select',
                optionNum: 'SALARY_CONFIRM_STATUS',
                colorPoints: [
                    {
                        color: '#C0C5CF',
                        value: '1',
                    },
                    {
                        color: '#0BB861',
                        value: '2',
                    },
                    {
                        color: '#F44837',
                        value: '3',
                    },
                    {
                        color: '#FFA628',
                        value: '4',
                    },
                ],
            },
            {
                prop: 'legalContractCode',
                label: '法务合同号（合同）',
            },
        ],
        // action: [],
        // actionWidth: 100,
    },
    perform: {
        columns: [
            {
                prop: 'logicalWarehouseName',
                label: '逻辑仓',
            },
            {
                prop: 'supplierName',
                label: '供应商',
            },
            {
                prop: 'kpiAssessmentScore',
                label: 'KPI考核得分',
            },
            {
                prop: 'recalculateOperationalQuality',
                label: '运作质量',
                type: 'select',
                optionNum: 'SRM_OPERATIONAL_QUALITY',
                colorPoints: [
                    {
                        color: '#2881FF',
                        value: '1',
                    },
                    {
                        color: '#C0C5CF',
                        value: '2',
                    },
                    {
                        color: '#C0C5CF',
                        value: '3',
                    },
                    {
                        color: '#0BB861',
                        value: '4',
                    },
                    {
                        color: '#FFA628',
                        value: '5',
                    },
                    {
                        color: '#F44837',
                        value: '6',
                    },
                ],
            },
            {
                prop: 'isRectificationIssued',
                label: '是否下发整改',
                type: 'select',
                optionNum: 'SRM_IS_RECTIFICATION_ISSUED',
            },
        ],
        // action: [],
        // actionWidth: 100,
    },
    contract: {
        columns: [
            {
                prop: 'contractCode',
                label: '合同编码',
            },
            {
                prop: 'suppliersName',
                label: '供应商名称',
            },
            {
                prop: 'contractStatus',
                label: '合同状态',
                type: 'select',
                optionNum: 'SRM_CONTRACT_STATUS',
            },
            {
                prop: 'businessType',
                label: '业务类型',
                type: 'select',
                optionNum: 'SRM_BUSYNESS_TYPE_BACKGROUND',
            },
        ],
        action: [
            {
                // type: 'text',
                label: '去查看',
                // size: 'small',
                event: 'view',
                // ifHas: '/largeWhBillModel-40',
            }
        ],
        actionWidth: 100,
    },
}

export default config